import {call, put, takeLatest, select} from 'redux-saga/effects'
import Alert from 'react-s-alert';
import {defineTypes} from '../../helpers'
import UserEndpoint from '../../persistence/UserEndpoint'
import LocationEndpoint from '../../persistence/LocationEndpoint'
import CompanyEndpoint from '../../persistence/CompanyEndpoint'
import {reduxFetch} from '../../http/reduxFetch'
import {push} from 'react-router-redux'
import merge from 'deepmerge'
import ReactTooltip from 'react-tooltip'
import _ from 'lodash'

const accountUpdateTypes = {...defineTypes('ACCOUNT/UPDATE')}
const accountTypes = {...defineTypes('ACCOUNT')}

export const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  account_info: {}
}

export const actions = {
  getAccountCompany() {
    return {type: 'GET_ACCOUNT'}
  },
  handleFeeChange(dropdownValue) {
    return {type: 'HANDLE_FEES', fees: dropdownValue['value']}
  },
  toggle(value) {
    return {type: 'TOGGLE_VALUE', value: value}
  },
  salesTaxChange(event) {
    return {type: 'SET_SALES_TAX', value: event.target.value}
  },
  updateAccount(create = null) {
    return {type: accountUpdateTypes.REQUEST, create: create}
  },
  handleKegSizes(value) {
    return {type: 'HANDLE_KEG_SIZES', value: value}
  },
  setUserRole(value, role) {
    return {type: 'SET_USER_ROLE', value: value, role: role}
  },
  setUserIdToDelete(value) {
    return {type: 'SET_DELETE_USER', delete_id: value['value']}
  },
  deleteUser() {
    return {type: 'DELETE_USER'}
  },
  createLocation(value) {
    return {type: 'CREATE_LOCATION', location_name: value}
  },
  deleteLocation(value) {
    return {type: 'DELETE_LOCATION', location_id_to_delete: value}
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case accountUpdateTypes.REQUEST:
      return {...state, loading: true, loaded: false}
    case accountUpdateTypes.FAILURE:
      return {...state, loading: false, errors: action.errors}
    case accountUpdateTypes.SUCCESS:
      return {...state, loading: false}
    case 'GET_ACCOUNT':
      return {...state, loading: true, loaded: false, loading: true}
    case 'GET_ACCOUNT_SUCCESS':
      return {...state, loading: false, loaded: true, account_info: action.account_info}
    case 'HANDLE_FEES':
      let new_account_info = {
        ...state.account_info,
        passOn: action.fees === 'pass_on'
          ? true
          : false
      }
      return {...state, account_info: new_account_info}
    case 'CREATE_STRIPE_INFO':
      return {...state, loading: true, created: false}
    case 'UPDATE_KEG_SIZES':
      let kegSizes = []
      action.kegSizes.map(kegSize => {
        kegSizes.push({
          value: kegSize['id'],
          label: _.startCase(kegSize['size'])
        })
      })

      return {...state, selectedKegSizes: kegSizes}
    case 'HANDLE_KEG_SIZES':
      return {...state, selectedKegSizes: action.value}
    case 'TOGGLE_VALUE':
      let new_toggle_info = {
        ...state.account_info,
        [action.value]: !state.account_info[action.value]
      }
      return {...state, account_info: new_toggle_info}
    case 'SET_SALES_TAX':
      let new_sales_tax = {
        ...state.account_info,
        salesTax: action.value
      }
      return {...state, account_info: new_sales_tax}
    case 'NEW_DISCOUNT':
      return {...state, loading: true}
    case 'SET_USER_ROLE':
      return {...state}
    case 'SET_DELETE_USER':
      return {...state, delete_id: action.delete_id}
    case 'DELETE_USER':
      return {...state}
    case 'CREATE_LOCATION':
      return {...state, location_name: action.location_name}
    case 'DELETE_LOCATION':
      return {...state, location_id_to_delete: action.location_id_to_delete}
    default:
      return state
  }
}

export const selectors = {
  account_form: (state) => {
    return state.form && state.form.account_settings_form && state.form.account_settings_form.values
  },
  account_info: ({accountUpdate}) => {
    return accountUpdate.account_info
  },
  company_id: ({accountUpdate}) => {
    return accountUpdate && accountUpdate.account_info && accountUpdate.account_info.id
  },
  loaded: (store) => {
    return store.accountUpdate
      && store.accountUpdate.loaded
  },
  collectSalesTax: (store) => {
    return store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.collectSalesTax
  },
  salesTax: (store) => {
    return store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.salesTax
  },
  collectTips: (store) => {
    return store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.collectTips
  },
  passOn: (store) => {
    return store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.passOn
  },
  allKegSizes: (store) => {
    return store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.allKegSizes
  },
  updateFormValues: ({form}) => {
    return form
      && form.account_settings_form
      && form.account_settings_form.values
  },
  handTapDeposit: ({form}) => {
    return form
      && form.account_settings_form
      && form.account_settings_form.values
      && form.account_settings_form.values.handTap
  },
  kegDeposit: ({form}) => {
    return form
      && form.account_settings_form
      && form.account_settings_form.values
      && form.account_settings_form.values.keg
  },
  fees: (store) => {
    let companyFees = store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.fees

    let initFees = [
      {'name': 'handTapPrice', 'value': undefined},
      {'name': 'handTapDeposit', 'value': undefined},
      {'name': 'kegDeposit', 'value': undefined}
    ]
    const otherFees = companyFees && companyFees.filter(fee => {
      let initFeeNames = ['handTapPrice', 'handTapDeposit', 'kegDeposit']
      return !initFeeNames.includes(fee['name'])
    })

    initFees.map(initFee => {
      let feeToMerge = companyFees && companyFees.find(companyFee => {
        return companyFee['name'] === initFee['name']
      })

      feeToMerge && feeToMerge[0] ? otherFees && otherFees.push({...feeToMerge, ...initFee}) : otherFees && otherFees.push(initFee)
    })

    return otherFees
  },
  selectedKegSizes: ({accountUpdate}) => {
    return accountUpdate && accountUpdate.selectedKegSizes || []
  },
  discounts: ({accountUpdate}) => {
    let discounts = accountUpdate
      && accountUpdate.account_info
      && accountUpdate.account_info.discounts
    return discounts
  },

  initialValues: (store) => {
    let account_info = store
      && store.accountUpdate
      && store.accountUpdate.account_info

    let fees = store
      && store.accountUpdate
      && store.accountUpdate.account_info
      && store.accountUpdate.account_info.fees

    fees && fees.map(fee => {
      account_info[fee['name']] = fee['value']
    })

    return account_info
  },
  users: ({accountUpdate}) => {
    return accountUpdate
      && accountUpdate.account_info
      && accountUpdate.account_info.users
  },
  locations: ({accountUpdate}) => {
    return accountUpdate
      && accountUpdate.account_info
      && accountUpdate.account_info.locations
  },
  delete_id: ({accountUpdate}) => {
    return accountUpdate
      && accountUpdate.delete_id
  },
  create_location_name: ({form}) => {
    return form
      && form.create_location_form
      && form.create_location_form.values
      && form.create_location_form.values.new_location_name
  },
  company_hours: ({form}) => {
    return form
      && form.account_info
      && form.account_info.company_hours
  }
}

function mergeEquallyLabeledTypes(collector, type) {
  var key = type.name
  var store = collector.store;
  var storedType = store[key];
  if (storedType) {
    storedType.children = storedType.children && storedType.children.concat(type.children);
  } else {
    store[key] = type;
    collector.list.push(type);
  }
  return collector;
}

export function* accountUpdateSaga(action) {
  try {
    ReactTooltip.rebuild();
    let company_params = {}
    company_params['collect_sales_tax'] = yield select(selectors.collectSalesTax)
    company_params['sales_tax'] = yield select(selectors.salesTax)
    company_params['collect_tips'] = yield select(selectors.collectTips)
    company_params['pass_on'] = yield select(selectors.passOn)


    let formValues = yield select(selectors.updateFormValues)
    let fees = yield select(selectors.fees)
    fees.map(fee => {
      fee['value'] = formValues[fee['name']] || ''
      fee['type'] = fee['name'] === 'handTapPrice' ? 'fee' : 'deposit'
      fee['name'] = fee['name'] || ''
    })

    let filteredFees = fees.filter(fee => {
      let feeNames = ['handTapPrice', 'handTapDeposit', 'kegDeposit']
      return feeNames.includes(fee['name'])
    })

    let companyFees = filteredFees && filteredFees.reduce(mergeEquallyLabeledTypes, {store: {}, list: []}).list

    company_params['fees'] = companyFees

    let discounts = yield select(selectors.discounts)
    discounts.map(discount => {
      discount['name'] = discount['name']
      discount['value'] = formValues[discount['name']] || discount['value']
    })

    let company_discounts = discounts && discounts.reduce(mergeEquallyLabeledTypes, {store: {}, list: []}).list

    company_discounts.push({
      'name': formValues['new_discount_name'],
      'value': formValues['new_discount_percentage']
    })

    let filteredDiscounts = company_discounts.filter(discount => {
      return !!((discount['name'] && 0 !== discount['name'].length) || (discount['value'] && 0 !== discount['value'].length))
    })

    company_params['discounts'] = filteredDiscounts

    let keg_sizes = yield select(selectors.selectedKegSizes)
    company_params['keg_sizes'] = keg_sizes

    let account_id = yield select(selectors.company_id)

    let form_values = yield select(selectors.account_form)

    company_params['future_date_limit'] = form_values && form_values['futureDateLimit']
    company_params['charge_deposit_date_limit'] = form_values && form_values['chargeDepositDateLimit']
    company_params['return_date_limit'] = form_values && form_values['returnDateLimit']
    company_params['available_date_limit'] = form_values && form_values['availableDateLimit']
    company_params['wait_for_reservations'] = form_values && form_values['waitForReservations']
    company_params['company_hours'] = form_values && form_values['companyHours']

    const accountUpdate = yield call(reduxFetch, CompanyEndpoint.update(company_params, account_id))
    if (accountUpdate['data']) {
      yield put({type: 'GET_ACCOUNT_SUCCESS', account_info: accountUpdate && accountUpdate.data && accountUpdate.data.attributes})
      yield put({type: accountUpdateTypes.SUCCESS})
      yield call(Alert.success, '<div>Account Info Updated!</div>')
      if (!!action.create) yield put(push('/account_cheers'))
      if (!action.create) yield put(push('/settings'))
    } else {
      yield put({type: accountUpdateTypes.FAILURE, errors: accountUpdate['errors']})
    }
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* showAccountSaga() {
  try {
    const response = yield call(reduxFetch, CompanyEndpoint.show())
    yield put({type: 'GET_ACCOUNT_SUCCESS', account_info: response.data.attributes})
    yield put({type: 'UPDATE_KEG_SIZES', kegSizes: response.data.attributes['selectedKegSizes']})
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* createLocationSaga(action) {
  try {
    let form = {}
    let create_location_name = yield select(selectors.create_location_name)
    form['location_name'] = create_location_name
    const response = yield call(reduxFetch, LocationEndpoint.new({location: form}))
    if (response['data']) {
      yield put({type: accountUpdateTypes.SUCCESS})
      yield put({type: 'GET_ACCOUNT'})
      yield call(Alert.success, '<div>Location Created!</div>')
    } else {
      yield put({type: accountUpdateTypes.FAILURE, errors: response['errors']})
    }
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* deleteLocationSaga(action) {
  try {
    const response = yield call(reduxFetch, LocationEndpoint.delete(action.location_id_to_delete))
    if (response['data']) {
      yield put({type: accountUpdateTypes.SUCCESS})
      yield put({type: 'GET_ACCOUNT'})
      yield call(Alert.success, '<div>Location Destroyed!</div>')
    } else {
      yield put({type: accountUpdateTypes.FAILURE, errors: response['errors']})
    }
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* updateUserSaga(action) {
  try {
    let form = {}
    form['role'] = action.role
    form['user_ids'] = action.value
    const response = yield call(reduxFetch, UserEndpoint.roles(form))
    if (response['data']) {
      yield put({type: accountUpdateTypes.SUCCESS})
      yield put({type: 'GET_ACCOUNT'})
      yield call(Alert.success, '<div>User Roles Updated!</div>')
    } else {
      yield put({type: accountUpdateTypes.FAILURE, errors: response['errors']})
    }
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* deleteUserSaga(action) {
  try {
    let user_id = yield select(selectors.delete_id)
    const response = yield call(reduxFetch, UserEndpoint.delete(user_id))
    if (response['data']) {
      yield put({type: accountUpdateTypes.SUCCESS})
      yield put({type: 'GET_ACCOUNT'})
      yield call(Alert.success, '<div>User removed</div>')
    } else {
      yield put({type: accountUpdateTypes.FAILURE, errors: response['errors']})
    }
  } catch (error) {
    yield put({type: accountUpdateTypes.FAILURE, errors: error})
  }
}

export function* rootSaga() {
  yield takeLatest(accountUpdateTypes.REQUEST, accountUpdateSaga)
  yield takeLatest('GET_ACCOUNT', showAccountSaga)
  yield takeLatest('SET_USER_ROLE', updateUserSaga)
  yield takeLatest('DELETE_USER', deleteUserSaga)
  yield takeLatest('DELETE_LOCATION', deleteLocationSaga)
  yield takeLatest('CREATE_LOCATION', createLocationSaga)
  // yield takeLatest('TOGGLE_VALUE', accountUpdateSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/account/update.js